import React, { useState } from "react";

export default function StudentLogin({ onSubmit }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",   // Added email here
    grade: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",  // Added email error here
    grade: "",
  });

  const handleStart = () => {
    let newErrors = { name: "", email: "", grade: "" };
    let hasError = false;

    if (!formData.name.trim()) {
      newErrors.name = "Please enter your full name.";
      hasError = true;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Please enter your email address.";
      hasError = true;
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
      hasError = true;
    }

    if (!formData.grade) {
      newErrors.grade = "Please select your grade.";
      hasError = true;
    }

    setErrors(newErrors);
    if (!hasError) {
      onSubmit(formData);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.cardHeader}>
          <img src="/logo1.png" alt="Left Logo" style={styles.logo} />
          <img src="/logo2.png" alt="Right Logo" style={styles.logo} />
        </div>

        <h2 style={styles.title}>Welcome to the RMA STEM Program</h2>
        <p style={styles.subtitle}>Please enter your details to begin</p>

        <input
          style={styles.input}
          type="text"
          placeholder="Full Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        {errors.name && <p style={styles.error}>{errors.name}</p>}

        <input
          style={styles.input}
          type="email"
          placeholder="Email Address"    
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
        {errors.email && <p style={styles.error}>{errors.email}</p>}

        <select
          style={styles.input}
          value={formData.grade}
          onChange={(e) => setFormData({ ...formData, grade: e.target.value })}
        >
          <option value="">Select Grade</option>
          <option value="7">Grade 7</option>
          <option value="8">Grade 8</option>
        </select>
        {errors.grade && <p style={styles.error}>{errors.grade}</p>}

        <button style={styles.button} onClick={handleStart}>
          Start Quiz
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "Montserrat, sans-serif",
    minHeight: "100vh",
    background: "linear-gradient(to right, #f5f7fa, #e2e4e8)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "40px 25px 30px",
    boxShadow: "0 12px 40px rgba(0, 21, 74, 0.15)",
    width: "100%",
    maxWidth: 440,
    textAlign: "center",
    position: "relative",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  logo: {
    height: 40,
    objectFit: "contain",
  },
  title: {
    marginBottom: 10,
    fontSize: 26,
    fontWeight: 700,
    color: "#00154A",
  },
  subtitle: {
    marginBottom: 25,
    fontSize: 14,
    color: "#333333",
  },
  input: {
    width: "100%",
    padding: "12px 15px",
    marginBottom: 5,
    border: "1px solid #E2E4E8",
    borderRadius: 10,
    fontSize: 16,
    backgroundColor: "#f9f9f9",
    outline: "none",
    transition: "border 0.2s ease",
    boxSizing: "border-box",
  },
  button: {
    background: "#02A552",
    color: "#fff",
    padding: "14px 20px",
    border: "none",
    borderRadius: 10,
    fontSize: 16,
    cursor: "pointer",
    width: "100%",
    marginTop: 15,
    boxShadow: "0 4px 12px rgba(2, 165, 82, 0.25)",
    transition: "background 0.3s ease",
  },
  error: {
    color: "#D32F2F",
    fontSize: 13,
    marginBottom: 10,
    textAlign: "left",
  },
};







